/** 
* @baidu/fe-monitor.js v0.8.5
* (c) 2018-2023 gukunfeng
*/

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = global || self, factory(global.Monitor = {}));
}(this, (function (exports) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    /**
     * @file src/utils/index
     * @author gukunfeng
     */
    /**
     * 获取当前的 UTC 时间戳
     *
     * @return {string} 时间字符串
     */
    function getCurrentUTCTime() {
        return new Date().toISOString();
    }
    function genUID() {
        function rand16Num(len) {
            if (len === void 0) { len = 0; }
            var result = [];
            for (var i = 0; i < len; i++) {
                result.push('0123456789abcdef'.charAt(Math.floor(Math.random() * 16)));
            }
            return result.join('');
        }
        return [
            (new Date()).valueOf().toString(),
            rand16Num(4)
        ].join('');
    }
    /**
     * 将对象转换为可作为URI参数的字符串
     * 例如: {a:1} => "%7B%22a%22%3A1%7D"
     *
     * @param {Object} obj 需要进行转换的对象
     * @return {string} 转换完成的字符串
     */
    function objectToURIString(obj) {
        return encodeURIComponent(JSON.stringify(obj));
    }
    /**
     * 截流函数
     *
     * @param {Function} func 需要包裹的函数
     * @param {number} timeout 限制的时间
     * @return {Function}
     */
    function throttle(func, timeout) {
        var timer = null;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (timer !== null) {
                clearTimeout(timer);
            }
            timer = setTimeout(function () {
                func.apply(null, args);
            }, timeout);
        };
    }
    /**
     * 获取当前域名的主域
     *
     * @example cloud.baidu.com 主域 baidu.com
     * @return {string} 当前域名的主域
     */
    function getMainHost() {
        var key = "mh_" + Math.random();
        var keyR = new RegExp("(^|;)\\s*" + key + "=12345");
        var expiredTime = new Date(0);
        var domain = document.domain;
        var domainList = domain.split('.');
        var urlItems = [];
        // 主域名一定会有两部分组成
        urlItems.unshift(domainList.pop());
        // 慢慢从后往前测试
        while (domainList.length) {
            urlItems.unshift(domainList.pop());
            var mainHost = urlItems.join('.');
            var cookie = key + "=" + 12345 + ";domain=." + mainHost;
            document.cookie = cookie;
            // 如果cookie存在，则说明域名合法
            if (keyR.test(document.cookie)) {
                document.cookie = cookie + ";expires=" + expiredTime;
                return mainHost;
            }
        }
    }
    function isBaiduDomain(origin) {
        if (origin === void 0) { origin = location.origin; }
        return Boolean(origin.match(/baidu.com/));
    }

    /**
     * @file src/utils/cookie.js
     *
     * @author zfkun(zfkun@msn.com)
     */
    // tslint:disable
    var cookie = {};
    /**
     * 设置Cookie的值
     *
     * @public
     * @param {string} name cookie键名
     * @param {string} value cookie原始值
     * @param {Object=} options cookie选项
     * @param {boolean=} options.raw 是否不自动编码
     * @param {number|Date} options.expires 有效期，为数字时单位为毫秒
     * @param {string=} options.domain 域名
     * @param {string=} options.path 路径
     * @param {boolean=} options.secure 是否安全传输
     */
    cookie.set = function (name, value, options) {
        if (options === void 0) { options = {}; }
        if (!isValidName(name)) {
            return;
        }
        var date = options.expires;
        if (typeof date === 'number') {
            date = new Date();
            date.setTime(date.getTime() + options.expires);
        }
        document.cookie = name + '=' + (options.raw ? value : encodeURIComponent(value))
            + (date instanceof Date ? '; expires=' + date.toUTCString() : '')
            + (options.domain ? '; domain=' + options.domain : '')
            + (options.path ? '; path=' + options.path : '')
            + (options.secure ? '; secure' : '');
    };
    /**
     * 获取Cookie的值
     *
     * @public
     * @param {string} name cookie键名
     * @param {Object=} options cookie选项
     * @param {boolean=} options.raw 是否不自动编码
     * @return {?string} 获取的cookie值，获取不到时返回null
     */
    cookie.get = function (name, options) {
        if (options === void 0) { options = {}; }
        return parseCookie(isValidName(name) ? name : '', !options.raw);
    };
    /**
     * 删除Cookie
     *
     * @public
     * @param {string} name 需要删除cookie的键名
     * @param {Object=} options 需要删除cookie的配置
     * @param {string=} options.domain 域名
     * @param {string=} options.path 路径
     * @param {boolean=} options.secure 是否安全传输
     */
    cookie.remove = function (name, options) {
        if (options === void 0) { options = {}; }
        options.raw = !0;
        options.expires = new Date(0);
        this.set(name, '', options);
    };
    /**
     * 空字符串检查
     *
     * @inner
     * @param {?string} str 目标字符串
     * @return {boolean}
     */
    function isNotEmptyString(str) {
        return typeof str === 'string' && str !== '';
    }
    /**
     * 验证字符串是否合法的cookie键名
     *
     * @inner
     * @param {string} name 待验证的键名字符串
     * @return {boolean}
     */
    function isValidName(name) {
        return isNotEmptyString(name);
    }
    /**
     * 解析Cookie
     *
     * @inner
     * @param {string} name cookie键名
     * @param {boolean} needDecode 是否自动解码
     * @return {?string} 获取的cookie值，获取不到时返回null
     */
    function parseCookie(name, needDecode) {
        if (isNotEmptyString(name)) {
            var matches = String(document.cookie).match(new RegExp('(?:^|)' + name + '(?:(?:=([^;]*))|;|$)'));
            if (matches) {
                return needDecode ? decodeURIComponent(matches[1]) : matches[1];
            }
        }
        return null;
    }

    /**
     * @file src/plugin/site_session
     */
    /** localStorage Base */
    var SESSION_STORAGE_SESSION_NAME = 'MONITOR_SESSION_ID';
    /**
     * 获取已经保存的会话id
     *
     * @return {string | null} 已保存的会话id
     */
    function getSiteSession() {
        return localStorage.getItem(SESSION_STORAGE_SESSION_NAME);
    }
    /**
     * 生成并保存会话id
     *
     * @param {string} externalSession 手动设置sessionID
     * @return {string} 生成的 sessionId
     */
    function setSiteSession(externalSession) {
        var sessionId = externalSession || genUID();
        localStorage.setItem(SESSION_STORAGE_SESSION_NAME, sessionId);
        return sessionId;
    }
    var sessionStorageBaseSession = {
        'get': getSiteSession,
        'set': setSiteSession
    };
    /** Root Domain Cookie Base */
    var COOKIE_SESSION_NAME = 'MONITOR_CROSS_SUB_DOMAIN_TRACK_SESSION_ID';
    function getCookieSession() {
        var sessionId = cookie.get(COOKIE_SESSION_NAME);
        if (sessionId !== null) {
            // 如果sessionId存在，则重置过期时间为30分钟
            setCookieSession(sessionId);
        }
        return sessionId;
    }
    function setCookieSession(sessionId) {
        var factSessionId = sessionId || genUID();
        cookie.set(COOKIE_SESSION_NAME, factSessionId, {
            'domain': '.' + getMainHost(),
            'path': '/',
            'expires': 30 * 60 * 1000
        });
        return factSessionId;
    }
    var cookieBaseSession = {
        'get': getCookieSession,
        'set': setCookieSession
    };
    var iframeSrc =  'https://console.bce.baidu.com/asset/monitor/bce_monitor_session.html';
    var iframeOrigin = iframeSrc.match(/http.*\.com/)[0];
    var iframe = null;
    function loadBceFrame() {
        if (!location.host.includes('baidu.com')) {
            throw new Error('无法在非 *.baidu.com 域下使用 "bce" 模式记录 sessionId ');
        }
        iframe = document.createElement('iframe');
        iframe.src = iframeSrc;
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        return new Promise(function (resolve) {
            iframe.onload = function () {
                iframe.contentWindow.postMessage({
                    'action': 'getSession'
                }, iframeOrigin);
                function currentResolve(e) {
                    if (e.data.action === 'getSession') {
                        window.removeEventListener('message', currentResolve);
                        resolve(e.data.value);
                    }
                }
                window.addEventListener('message', currentResolve);
                // TODO: 增加超时机制
            };
        });
    }
    function getBceSession() {
        // 第一次获取
        if (iframe === null) {
            return loadBceFrame();
        }
        // 调用时第一次的函数还没返回
        // 由于后续页面的事件发送必须在 site_view之后，即 loadiframePromise 已经 resolve
        // else if (loadiframePromise) {
        //    return loadiframePromise;
        // }
        // 已经获取到 session
        return new Promise(function (resolve) {
            iframe.contentWindow.postMessage({
                'action': 'getSession'
            }, iframeOrigin);
            function currentResolve(e) {
                if (e.data.action === 'getSession') {
                    window.removeEventListener('message', currentResolve);
                    resolve(e.data.value);
                }
            }
            window.addEventListener('message', currentResolve);
        });
    }
    function setBceSession(sessionId) {
        var factSessionId = sessionId || genUID();
        iframe.contentWindow.postMessage({
            'action': 'setSession',
            'value': factSessionId
        }, iframeOrigin);
        return factSessionId;
    }
    var bceSiteSession = {
        'get': getBceSession,
        'set': setBceSession
    };

    var MONITOR_LAST_PAGE_VIEW_INFO = 'MINITOR_LAST_PAGE_VIEW';
    var MONITOR_CURRENT_PAGE_VIEW_INFO = 'MONITOR_CURRENT_PAGE_VIEW';
    /**
     * 存储当前页面的访问信息，用以计算页面的停留时长
     *
     * @return {String} pageViewId
     */
    function setPageViewInfo(pageViewEvent) {
        localStorage.setItem(MONITOR_LAST_PAGE_VIEW_INFO, JSON.stringify(pageViewEvent));
        return pageViewEvent;
    }
    /**
     * 从本地存储获取存储的页面访问信息
     *
     * @return {FullPageViewEvent}
     */
    function getPageViewInfo() {
        var event = localStorage.getItem(MONITOR_LAST_PAGE_VIEW_INFO);
        if (event === null) {
            return null;
        }
        else {
            var info = JSON.parse(event);
            var expire = new Date().getTime() - new Date(info.timestamp).getTime();
            if (expire > 60 * 30 * 1000) {
                localStorage.removeItem(MONITOR_LAST_PAGE_VIEW_INFO);
                return null;
            }
            else {
                return info;
            }
        }
    }
    /**
     * 如果用户同时打开多个页面，sessionStorage 会在每个 tab 重置
     * 所以使用 localstorage 记录
     * 但如果用户返回原来的标签里面点击，behavior 需要使用该标签的 viewId
     * 所以在两个地方均记录 pageView
     */
    function getCurrentPage() {
        var event = sessionStorage.getItem(MONITOR_CURRENT_PAGE_VIEW_INFO);
        if (event === null) {
            return null;
        }
        return JSON.parse(event);
    }
    function setCurrentPage(pageViewEvent) {
        sessionStorage.setItem(MONITOR_CURRENT_PAGE_VIEW_INFO, JSON.stringify(pageViewEvent));
        return pageViewEvent;
    }
    function getPageViewId() {
        var info = getCurrentPage();
        return info && info.pageViewId || '';
    }
    var pageViewPlugin = {
        getPageViewId: getPageViewId,
        getCurrentPage: getCurrentPage,
        setCurrentPage: setCurrentPage,
        get: getPageViewInfo,
        set: setPageViewInfo,
    };

    /**
     * @file src/utils/context
     * @author gukunfeng
     */
    var context = {
        get path() {
            return location.pathname;
        },
        get url() {
            return window.location.href;
        },
        get referrer() {
            return document.referrer;
        },
        get host() {
            return location.host;
        },
        get network() {
            var connection = navigator.connection;
            return connection ? connection.effectiveTyp : 'unknow';
        }
    };

    /**
     * @file src/track/page_view.js
     */
    var pageViewResolve = function (key) { };
    var pageViewGeneratedPromise = new Promise(function (resolve) {
        pageViewResolve = resolve;
    });
    function setupAutoPageViewTrack(info) {
        return __awaiter(this, void 0, void 0, function () {
            var siteSessionId, lastPageViewEvent, currentPageViewEvent, leaveEvent, storageView;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, info.session.get()];
                    case 1:
                        siteSessionId = _a.sent();
                        lastPageViewEvent = info.page.get();
                        currentPageViewEvent = genPageViewEventData(siteSessionId, lastPageViewEvent);
                        // 不为空，说明当前访问是从上一个页面跳转而来的，记录上一个页面的访问时间
                        if (lastPageViewEvent !== null) {
                            leaveEvent = genPageLeaveEventData(lastPageViewEvent, currentPageViewEvent);
                            trackPageLeave(leaveEvent);
                        }
                        if (typeof pageViewResolve === 'function') {
                            pageViewResolve(currentPageViewEvent.pageViewId);
                        }
                        storageView = __assign({ 'timestamp': getCurrentUTCTime() }, currentPageViewEvent);
                        // 存储当前页面的访问数据
                        info.page.set(storageView);
                        info.page.setCurrentPage(storageView);
                        trackPageView(currentPageViewEvent);
                        return [2 /*return*/];
                }
            });
        });
    }
    function trackPageView(data) {
        return trackRequest('page_view', __assign({}, data));
    }
    function trackPageLeave(data) {
        return trackRequest('page_leave', __assign({}, data));
    }
    function genPageViewEventData(siteSessionId, lastPageViewEvent) {
        var pageCount = 1;
        if (lastPageViewEvent) {
            pageCount = lastPageViewEvent.pageCount ? lastPageViewEvent.pageCount + 1 : 1;
        }
        return {
            siteSessionId: siteSessionId,
            'pageViewId': genUID(),
            'pageCount': pageCount,
            'lastPageViewId': lastPageViewEvent && lastPageViewEvent.pageViewId,
            'pagePath': location.pathname,
            'pageUrl': location.href,
            'pageReferrer': context.referrer,
            'pageTitle': document.title
        };
    }
    /**
     * 通过使用保存上一次访问页面的信息，计算出页面停留时长，然后发送 pageLeave 事件
     *
     * @param lastPageviewEvent 上一次页面访问记录的访问信息
     */
    function genPageLeaveEventData(lastPageviewEvent, currentPageViewEvent) {
        var event = {
            'siteSessionId': lastPageviewEvent.siteSessionId,
            'pageViewId': lastPageviewEvent.pageViewId,
            'nextPageViewId': currentPageViewEvent.pageViewId,
            'pagePath': lastPageviewEvent.pagePath,
            'pageUrl': lastPageviewEvent.pageUrl,
            'pageReferrer': lastPageviewEvent.pageReferrer,
            'pageVisitLength': calcVisitLength(lastPageviewEvent.timestamp)
        };
        return event;
    }
    /**
     * 用以计算页面停留时长。
     *
     * @param viewStartTime 上一个页面进入的时间
     */
    function calcVisitLength(viewStartTime) {
        return new Date().getTime() - new Date(viewStartTime).getTime();
    }

    /**
     * @file src/request.js
     * @author gukunfeng
     */
    function trackRequest(type, trackData) {
        var data = __assign(__assign({ type: type, appTag: monitorConfig.appTag, experiment: monitorConfig.experiment, baiduId: monitorConfig.baiduId, accountId: monitorConfig.accountId }, trackData), { timestamp: getCurrentUTCTime() });
        var statitUrl = monitorConfig.api + "?newTrackData=" + objectToURIString(data);
        new Image().src = statitUrl;
    }
    function trackBehavior(eventData) {
        return __awaiter(this, void 0, void 0, function () {
            var siteSession;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isBaiduDomain()) return [3 /*break*/, 2];
                        return [4 /*yield*/, bceSiteSession.get()];
                    case 1:
                        siteSession = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        siteSession = sessionStorageBaseSession.get();
                        _a.label = 3;
                    case 3:
                        trackRequest('behavior', __assign(__assign({}, eventData), { pageViewId: pageViewPlugin.getPageViewId(), siteSessionId: siteSession }));
                        return [2 /*return*/];
                }
            });
        });
    }
    /**
     * 由于用户可能手动在页面进入的时候就发送日志
     * 但是此时可能 pageid 还未生成，所以会等到 pageViedId 生成后发送
     *
     * @param {object} eventData 事件信息
     * @returns {Promise} null
     */
    function trackBehaviorTimeout(eventData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                pageViewGeneratedPromise.then(function () {
                    trackBehavior(eventData);
                });
                return [2 /*return*/];
            });
        });
    }

    /**
     * @file src/track/behavior
     * @author gukunfeng
     */
    var TRACK_NAME_TAG = 'data-track-name';
    var TRACK_ACTION_TAG = 'data-track-action';
    var TRACK_CATEGORY_TAG = 'data-track-category';
    var ERROR_TRACK_CATEGORY_TAG = 'data-track-categoary';
    var TRACK_VALUE_TAG = 'data-track-value';
    var BehaviorTracker = /** @class */ (function () {
        function BehaviorTracker(config, info) {
            var _this = this;
            this.actionHandler = function (e) {
                // Event.currentTarget兼容性为IE9+，但这里的代码看样子只兼容了IE9+（用了addEventListener），所以就暂不做兼容性处理
                _this.logger(e.type, e.currentTarget);
            };
            this.info = info;
            this.addElementListener([document.body]);
            if (config.autoTrack) {
                this.initAutoWatcher();
            }
        }
        BehaviorTracker.prototype.addElementListener = function (nodeList) {
            var _this = this;
            Array.prototype.forEach.call(nodeList, function (node) {
                if (node.nodeType !== Node.ELEMENT_NODE) {
                    return;
                }
                // Todo: 兼容性
                var trackElements = node.querySelectorAll("[" + TRACK_NAME_TAG + "]:not(a)");
                var linkElements = node.getElementsByTagName('a');
                var bindListener = function (elements) {
                    Array.prototype.forEach.call(elements, function (ele) {
                        // 由于 ie6-10 对 dataset 支持不良好，使用 getAttribute
                        var trackAction = ele.getAttribute(TRACK_ACTION_TAG) || 'click';
                        ele.addEventListener(trackAction, _this.actionHandler);
                    });
                };
                bindListener(trackElements);
                bindListener(linkElements);
            });
        };
        BehaviorTracker.prototype.logger = function (action, element) {
            var trackName = element.getAttribute(TRACK_NAME_TAG);
            var trackValue = element.getAttribute(TRACK_VALUE_TAG);
            var trackCategory = element.getAttribute(TRACK_CATEGORY_TAG);
            var errorTagTrackCategory = element.getAttribute(ERROR_TRACK_CATEGORY_TAG);
            var isLinkElement = function (ele) {
                // eslint-disable-next-line no-undefined
                return ele.href !== undefined;
            };
            var event = {
                action: action,
                category: trackCategory || errorTagTrackCategory,
                name: trackName,
                value: trackValue,
                href: isLinkElement(element) ? element.href : ''
            };
            for (var key in event) {
                if (!event[key]) {
                    event[key] = '';
                }
            }
            return this.sendEvent(event);
        };
        BehaviorTracker.prototype.sendEvent = function (eventData) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, siteSessionId, pageViewId;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, Promise.all([
                                this.info.session.get(),
                                this.info.page.getPageViewId()
                            ])];
                        case 1:
                            _a = _b.sent(), siteSessionId = _a[0], pageViewId = _a[1];
                            trackRequest('behavior', __assign(__assign({}, eventData), { pageViewId: pageViewId,
                                siteSessionId: siteSessionId }));
                            return [2 /*return*/];
                    }
                });
            });
        };
        BehaviorTracker.prototype.initAutoWatcher = function () {
            var _this = this;
            if (typeof window.MutationObserver !== 'function') {
                console.log('不支持 MutaionObserver');
                return;
            }
            var recordCache = [];
            var throttleAddListener = throttle(function (records) {
                var flattedNodelist = records
                    .map(function (record) { return record.addedNodes; })
                    // nodelist 不是数组，所以使用 Array.from 转换为数组
                    .reduce(function (acc, cur) { return acc.concat(Array.from(cur)); }, []);
                _this.addElementListener(flattedNodelist);
                // 需要在使用完之后清空已经使用的record列表
                // 此行为导致此函数不纯，需要重构
                recordCache = [];
            }, 500);
            var observer = new MutationObserver(function (records) {
                recordCache = recordCache.concat(records);
                throttleAddListener(recordCache);
            });
            observer.observe(document.body, {
                'childList': true,
                'subtree': true
            });
        };
        return BehaviorTracker;
    }());

    /**
     * @file src/track/campaign.ts
     * @author gukunfeng
     *
     * 如果 cookie 里面没有 CAMPAIGN_TRACK，那么在前端根据 params 里的值设置 cookie
     */
    var CAMPAIGN_TRACK = 'CAMPAIGN_TRACK';
    var CLOUD_IFRAME_SOURCE =  'https://cloud.baidu.com/helper/monitor.html';
    var CLOUD_ORIGIN = CLOUD_IFRAME_SOURCE.match(/http.*\.com/)[0];
    /**
     * 将url参数里的track参数的值，设置到当前域下的cookie中，并返回track参数的值
     */
    function setCampaignTrack() {
        var searchParams = searchToObject(location.search);
        var urlTrack = searchParams['track'];
        if (!urlTrack) {
            return urlTrack;
        }
        // 如果 url 里面有 track，则覆盖 cookie 里面的 track
        cookie.set(CAMPAIGN_TRACK, urlTrack, {
            domain: '.' + location.hostname,
            path: '/',
            expires: 90 * 24 * 60 * 60 * 1000
        });
        return urlTrack;
    }
    function searchToObject(search) {
        return search.slice(1).split('&')
            .reduce(function (acc, acu) {
            var _a = acu.split('='), name = _a[0], value = _a[1];
            acc[name] = value;
            return acc;
        }, {});
    }
    /**
     *  判断是否需要和官网同步一个track cookie
     * @param config Monitor初始化配置
     * @param trackVal 当前track的值
     */
    function needSyncCookieWithCloud(config, trackVal) {
        if (config.api !== DEFAULT_API || !trackVal) {
            return false;
        }
        /** 是否就是cloud.baidu.com */
        var isCloud = location.hostname === 'cloud.baidu.com';
        /** 是否是baidu的网站 */
        var isInBaidu = location.host.includes('baidu.com');
        return !isCloud && isInBaidu;
    }
    var cloudIframe;
    /**
     * 在有必要时，将当前站点的track信息同步给cloud.baidu.com，使得在向cloud域下的埋点接口发送请求的时一定会携带上此cookie
     * @param config Monitor的配置
     * @param trackVal 当前track的值
     */
    function syncTrackCookieWithCloud(config, trackVal) {
        if (cloudIframe || !needSyncCookieWithCloud(config, trackVal)) {
            // 如果已经同步过了，或者不需要同步，则直接完成当前异步任务
            return Promise.resolve();
        }
        cloudIframe = document.createElement('iframe');
        cloudIframe.src = CLOUD_IFRAME_SOURCE;
        cloudIframe.style.display = 'none';
        document.body.appendChild(cloudIframe);
        return new Promise(function (resolve, reject) {
            cloudIframe.onload = function () {
                cloudIframe.contentWindow.postMessage({
                    'action': 'syncTrackCookie',
                    'payload': trackVal
                }, CLOUD_ORIGIN);
                // 监听cloudIframe发出的确认消息，确认完成后再resolve
                function confirmHandler(e) {
                    var data = e.data;
                    if (data.action === 'syncTrackCookie' && data.payload) {
                        window.removeEventListener('message', confirmHandler);
                        resolve();
                    }
                }
                window.addEventListener('message', confirmHandler);
                // 超时机制，一直未成功时便直接resolve，即便没有成功同步cookie；这种情况下埋点数据会丢失track，作为backup也可以接受
                setTimeout(function () {
                    resolve();
                }, 7000);
            };
        });
    }

    /**
     * @file src/track/site_view.js
     */
    /**
     * 自动统计站点的访问会话次数和信息
     *
     * 1. 如果该页面是用户进入站点的第一个页面，则没有 session 信息，生成 session 并发送站点会话事件
     * 2. 如果当前页面不是用户在当前会话的第一个页面，则已经存在 session，不发送站点会话事件
     */
    function setupAutoSiteViewTrack(info) {
        return __awaiter(this, void 0, void 0, function () {
            var sessionId, siteViewEvent;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, info.session.get()];
                    case 1:
                        sessionId = _a.sent();
                        if (!!sessionId) return [3 /*break*/, 3];
                        return [4 /*yield*/, info.session.set()];
                    case 2:
                        sessionId = _a.sent();
                        siteViewEvent = __assign({ siteSessionId: sessionId, siteEntrance: context.url, siteReferrer: context.referrer, siteHost: context.host, network: context.network, campaignTrack: cookie.get('CAMPAIGN_TRACK') }, info.visitor.get());
                        trackRequest('site_view', siteViewEvent);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    }

    /**
     * @file src/plugin/visitor.plugin
     * 获取访问信息的插件
     */
    var MONITOR_VISITOR_ID = 'MONITOR_VISITOR_ID';
    /**
     * 获取访客信息，包括访客ID和访客类型（新老访客)
     *
     * 1. 用户首次进入站点，则生成访客 id 保存在 localStorage，并标识用户为新访客
     * 2. 用户进入站点，若存在 visitorId，则标识用户为老访客
     *
     * @return {VisitorInfo}
     */
    function getVisitorInfo() {
        var visitorId = localStorage.getItem(MONITOR_VISITOR_ID);
        if (!visitorId) {
            visitorId = monitorConfig.userid;
            localStorage.setItem(MONITOR_VISITOR_ID, visitorId);
            return {
                visitorId: visitorId,
                'visitorType': 'new'
            };
        }
        return {
            visitorId: visitorId,
            'visitorType': 'old'
        };
    }
    var visitorPlugin = {
        'get': getVisitorInfo
    };

    /**
     * @file src/plugin/router.plugin.ts
     * @author gukunfeng
     */
    function wrapEvent(type) {
        var orig = window.history[type];
        return function () {
            var rv = orig.apply(this, arguments);
            var e = new Event(type);
            e.arguments = arguments;
            window.dispatchEvent(e);
            return rv;
        };
    }
    function historyRouterListener(callback) {
        window.history.pushState = wrapEvent('pushState');
        window.history.replaceState = wrapEvent('replaceState');
        window.addEventListener('pushState', callback);
        window.addEventListener('replaceState', callback);
    }
    function hashRouterListener(callback) {
        window.addEventListener('hashchange', callback);
    }

    /**
     * @file src/track.js
     * @author gukunfeng
     */
    var Monitor = /** @class */ (function () {
        function Monitor(config) {
            var _this = this;
            switch (config.session) {
                case 'bce':
                    this.session = bceSiteSession;
                    break;
                case 'crossSubDomain':
                    this.session = cookieBaseSession;
                    break;
                case 'storage':
                    this.session = sessionStorageBaseSession;
                    break;
                default:
                    this.session = sessionStorageBaseSession;
            }
            switch (config.router) {
                case 'history':
                    historyRouterListener(this.trackPageViewEvent.bind(this));
                    break;
                case 'hash':
                    // TODO: hash 模式的话页面的 path 应该是 hash 的值
                    hashRouterListener(this.trackPageViewEvent.bind(this));
                    break;
                default:
                    console.error("router mode '" + config.router + "' isn't support.");
            }
            this.config = config;
            this.visitor = visitorPlugin;
            this.page = pageViewPlugin;
            this.tracker = this.initTracker();
            var trackVal = setCampaignTrack();
            syncTrackCookieWithCloud(config, trackVal).then(function () {
                if (config.autoTrack) {
                    _this.initAutoTrack();
                }
            });
        }
        Monitor.prototype.initTracker = function () {
            return {
                'behavior': new BehaviorTracker(this.config, {
                    'page': this.page,
                    'session': this.session
                })
            };
        };
        Monitor.prototype.initAutoTrack = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.trackSiteViewEvent()];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.trackPageViewEvent()];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        Monitor.prototype.trackSiteViewEvent = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, setupAutoSiteViewTrack({
                                'session': this.session,
                                'visitor': this.visitor
                            })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * 1. 后端渲染的网页，每次加载都会创建 Monitor 示例
         * 2. 单页面网址,需要在更新页面时手动调用该函数
         *
         * @returns {void}
         */
        Monitor.prototype.trackPageViewEvent = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, setupAutoPageViewTrack({
                                'session': this.session,
                                'page': this.page
                            })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        return Monitor;
    }());
    var DEFAULT_API = 'https://cloud.baidu.com/img/bh.gif';
    var defaultConfig = {
        'api': DEFAULT_API,
        'router': 'history',
        'userid': '',
        'autoTrack': true,
        'session': isBaiduDomain() ? 'bce' : 'storage'
    };
    var monitorConfig = defaultConfig;
    function init(config) {
        var fullConfig = __assign(__assign({}, defaultConfig), config);
        monitorConfig = fullConfig;
        if (monitorConfig.userid === '') {
            Object.defineProperty(monitorConfig, 'userid', {
                'get': genUID
            });
        }
        return new Monitor(fullConfig);
    }

    /**
     * @file src/main.js
     * @author gukunfeng
     */
    var main = {
        init: init,
        trackBehavior: trackBehaviorTimeout
    };

    exports.default = main;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=fe-monitor.js.map
